import { ReviewModalMetadata } from 'modules/review/components/ReviewActionsModal';
import { useCallback, useMemo, useState } from 'react';

export const useReviewModals = () => {
  const [modalMetadata, setModalMetadata] = useState<ReviewModalMetadata>({
    isOpen: false,
  });

  const createOpenModal = useCallback(
    (type: NonNullable<ReviewModalMetadata['type']>) =>
      (review: ReviewModalMetadata['review']): void => {
        setModalMetadata({ isOpen: true, type, review: review });
      },
    [],
  );

  const openRefuseModal = useMemo(
    () => createOpenModal('refuse'),
    [createOpenModal],
  );
  const openReplyModal = useMemo(
    () => createOpenModal('reply'),
    [createOpenModal],
  );
  const openReplyEditModal = useMemo(
    () => createOpenModal('reply-edit'),
    [createOpenModal],
  );
  const openCheckModal = useMemo(
    () => createOpenModal('check'),
    [createOpenModal],
  );
  const openSmsModal = useMemo(() => createOpenModal('sms'), [createOpenModal]);

  const closeModal = useCallback(() => {
    setModalMetadata({ isOpen: false });
  }, []);

  return {
    modalMetadata,
    openRefuseModal,
    openReplyModal,
    openReplyEditModal,
    openCheckModal,
    openSmsModal,
    closeModal,
  };
};
